import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiClientService } from '../../../core/http';
import type { CreateVariantRequest, ProductVariantDto, UpdateVariantRequest } from '../models/variant.model';

@Injectable({ providedIn: 'root' })
export class VariantsApiService {
  private readonly api = inject(ApiClientService);

  list(productId: string): Observable<{ data: ProductVariantDto[] }> {
    return this.api.get<{ data: ProductVariantDto[] }>(`/products/${productId}/variants`);
  }

  getById(productId: string, id: string): Observable<{ data: ProductVariantDto }> {
    return this.api.get<{ data: ProductVariantDto }>(`/products/${productId}/variants/${id}`);
  }

  create(productId: string, body: CreateVariantRequest): Observable<{ data: ProductVariantDto }> {
    return this.api.post<{ data: ProductVariantDto }>(`/products/${productId}/variants`, body);
  }

  update(productId: string, id: string, body: UpdateVariantRequest): Observable<{ data: ProductVariantDto }> {
    return this.api.patch<{ data: ProductVariantDto }>(`/products/${productId}/variants/${id}`, body);
  }

  delete(productId: string, id: string): Observable<{ data: { deleted: true } }> {
    return this.api.delete<{ data: { deleted: true } }>(`/products/${productId}/variants/${id}`);
  }
}
